import * as React from 'react'
import { render } from 'react-dom'
import App from './App'
import '../assets/tailwind.css'
import '../assets/font.ttf'

const rootElement = document.getElementById('app')
render(<App />, rootElement)
